import { render, staticRenderFns } from "./communicationMobile.vue?vue&type=template&id=35224018&"
import script from "./communicationMobile.vue?vue&type=script&lang=js&"
export * from "./communicationMobile.vue?vue&type=script&lang=js&"
import style0 from "./communicationMobile.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports